import API from './api';

const downloadFile = async (url, filename) => {
    // Get token from localStorage
    const token = localStorage.getItem('app-token');

    // Create headers with token
    const headers = {
        'Accept': 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
    };
    if (token) {
        headers['x-auth-token'] = token;
    }

    // Use fetch for getting stream
    const response = await fetch(url, {
        method: 'GET',
        headers: headers
    });

    // Check response status
    if (!response.ok) {
        throw new Error('Error during file downloading');
    }

    const reader = response.body.getReader();
    const fileStream = new ReadableStream({
        start(controller) {
            return pump();

            async function pump() {
                const { done, value } = await reader.read();
                if (done) {
                    controller.close();
                    return;
                }
                controller.enqueue(value);
                await pump();
            }
        }
    });

    // Create Blob from the stream
    const blob = await new Response(fileStream).blob();
    const urlForDownload = URL.createObjectURL(blob);
    
    const link = document.createElement('a');
    link.href = urlForDownload;
    link.download = filename;
    link.click();
    URL.revokeObjectURL(urlForDownload);
};

export default downloadFile;
